import Logman from '@farskid/logman';

export default new Logman('Shuffle');
